import './title4.css'
export default function Title4(){
    return(
        <>
       <div className="h"> <div className="head-4">
       </div></div>
        <div className="t">
        <h3 className='t-1'>Concentrated Flavors (oils)</h3>
        </div>
        </>
    )
}